import styled from '@emotion/styled';

export const TransparentGradient = styled.div`
  position: absolute;
  display: block;
  left: 0;
  width: 100%;
  bottom: 100%;
  height: 300px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 1) 100%);
`;

export const Wrapper = styled.div`
  width: 100%;
  position: relative;
`;
